import { GameServiceError } from "../domain/errors";

/** Prevent two WebViews of the same origin from overwriting one durable queue. */
export class ExclusiveTapSession {
  #release: (() => void) | null = null;
  async acquire(ownerKey: string): Promise<void> {
    if (this.#release !== null || typeof document === "undefined" || typeof navigator === "undefined" || !navigator.locks) return;
    await new Promise<void>((resolve, reject) => {
      void navigator.locks.request(`diamond-kingdom:active:${ownerKey}`, { ifAvailable: true }, async (lock) => {
        if (!lock) { reject(new GameServiceError("SESSION_OPEN", "Another game window owns the tap queue")); return; }
        await new Promise<void>((release) => { this.#release = release; resolve(); });
      }).catch(reject);
    });
  }
  release(): void { this.#release?.(); this.#release = null; }
}
